export function getNotificationRouteDict(notification) {
  let routeDict = {}

  if (notification.object_delta.primary_order_id) {
    routeDict = {
      pathname: `/orders/${notification.object_delta.primary_order_id}`,
      state: {
        followUpOrder: notification.notification_object_id,
      },
    }
  } else if (notification.notification_object_id) {
    routeDict = {
      pathname: `/orders/${notification.notification_object_id}`,
    }
  }

  if (notification.object_delta.OVERRIDE_PATHNAME) {
    routeDict = {
      pathname: notification.object_delta.OVERRIDE_PATHNAME,
    }
  }

  return routeDict
}
